/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import { DepressionValuesFragmentDoc } from './DepressionProfile';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDepressionProfileMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateDepressionInput;
}>;


export type UpdateDepressionProfileMutation = { __typename?: 'Mutation', updateDepression: { __typename?: 'UpdateDepressionPayload', nextStepPath: string | null, form: { __typename?: 'Depression', id: string, diagnosedAt: string | null, severity: string | null, currentlyTreated: boolean | null, everTreated: boolean | null, treatmentEndDate: string | null, numberOfMedications: number | null, psychotherapy: boolean | null, hospitalized: boolean | null, hospitalizedAt: string | null } } | null };


export const UpdateDepressionProfileDocument = gql`
    mutation UpdateDepressionProfile($input: UpdateDepressionInput!) {
  updateDepression(input: $input) {
    form {
      id
      ...DepressionValues
    }
    nextStepPath
  }
}
    ${DepressionValuesFragmentDoc}`;
export type UpdateDepressionProfileMutationFn = Apollo.MutationFunction<UpdateDepressionProfileMutation, UpdateDepressionProfileMutationVariables>;
export function useUpdateDepressionProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepressionProfileMutation, UpdateDepressionProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepressionProfileMutation, UpdateDepressionProfileMutationVariables>(UpdateDepressionProfileDocument, options);
      }
export type UpdateDepressionProfileMutationHookResult = ReturnType<typeof useUpdateDepressionProfileMutation>;
export type UpdateDepressionProfileMutationResult = Apollo.MutationResult<UpdateDepressionProfileMutation>;
export type UpdateDepressionProfileMutationOptions = Apollo.BaseMutationOptions<UpdateDepressionProfileMutation, UpdateDepressionProfileMutationVariables>;